import { createSelectionListViewContainer } from 'factories/SelectionListView'
import operatorActions from 'actions/operators'
import Component from 'components/Jobs/Labour/FormView/SelectOperator'

export default createSelectionListViewContainer({
  extraDispatchToProps: (dispatch, props) => ({
    getItems: (params = {}) => dispatch(operatorActions.getOptions({ active: 'Active', ...params })),
  }),
})(Component)
